import React from "react";
import {connect} from "react-redux";
import {reduxForm, Field, SubmissionError} from "redux-form";
import {compose, withHandlers} from "recompose";
import {map} from "lodash";
import Button from "react-md/lib/Buttons/Button";

import SelectField from "../form/SelectField";
import * as Validation from "../form/Validation";

import {installPackage} from "../../actions/resourceActions";


function getBackUrl(hostId, serverId, organizationId) {
    let backUrl = null;
    let comingFromHostsServerOrganization = hostId && serverId;

    if (comingFromHostsServerOrganization) {
        let urlToHostsServerOrganization = `/hosts/${hostId}/${serverId}/${organizationId}`;
        backUrl = urlToHostsServerOrganization;
    }
    else {
        let urlToMyAtollon = `/organizations/${organizationId}`;
        backUrl = urlToMyAtollon;
    }

    return backUrl;
}

const Form = ({
                  handleSubmit,
                  change,
                  history,
                  hostId,
                  serverId,
                  organizationId,
                  packageObject
              }) => {

    if (organizationId && packageObject)
    {
        let backUrl = getBackUrl(hostId, serverId, organizationId);
        const options = map(packageObject.locales, item => {
            return {value: item, label: item};
        });

        return (
            <form onSubmit={handleSubmit} className="form">
                <div className="flex-row">
                    <p className="info-label">name:</p>
                    <p>{packageObject.name}</p>
                </div>
                <div className="flex-row">
                    <p className="info-label">version:</p>
                    <p>{packageObject.version}</p>
                </div>
                <Field
                    component={SelectField}
                    label="locale"
                    name="locale"
                    menuItems={options}
                    validate={[Validation.required]}
                />
                <div className="flex-row flex-right">
                    <Button
                        flat
                        label="Zrušit"
                        className="btn"
                        onClick={() =>
                        {
                            return history.push(backUrl);
                        }}
                    />
                    <Button
                        flat
                        primary
                        label="Instalovat"
                        type="submit"
                        className="btn btn-primary"
                    />
                </div>
            </form>
        );
    }
    return <div/>;
};

export default compose(
    connect(null, {installPackage}),
    withHandlers({
        onSubmit: () => async (formData, dispatch, props) =>
        {
            const {
                hostId,
                serverId,
                organizationId,
                history,
                packageObject,
                installPackage
            } = props;

            let backUrl = getBackUrl(hostId, serverId, organizationId);

            if (
                await installPackage(organizationId, {
                    name: packageObject.name,
                    version: packageObject.version,
                    locale: formData.locale
                })
            )
            {
                history.push(backUrl);
            }
            else
            {
                throw new SubmissionError({
                    locale: "Přidání modulu se nepodařilo."
                });
            }
        }
    }),
    reduxForm({form: "packageNewForm"})
)(Form);



// WEBPACK FOOTER //
// ./src/components/packageNew/Form.js